import { render } from "./CoffersGold.vue?vue&type=template&id=9d8da21a&scoped=true"
import script from "./CoffersGold.vue?vue&type=script&lang=js"
export * from "./CoffersGold.vue?vue&type=script&lang=js"

import "./CoffersGold.vue?vue&type=style&index=0&id=9d8da21a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9d8da21a"

export default script